/**
 * 3DA fast add-to-cart for product cards (home, collection, search, cart upsells, 8-piece cards).
 * Posts to /cart/add.js and updates the header cart count in place, so there is no full page
 * reload per add, which matters most inside Facebook / Instagram in-app browsers. If anything
 * fails it falls back to the native form submit, so an add is never lost. Product pages keep
 * their native submit (buying intent -> go to the cart). The home Mix & Match grid has its own
 * handler and is skipped here. On the cart page the cart section is refreshed in place.
 */
(function () {
  var FORM_SELECTOR = '.card form, .upsell-card form, .tda-eight-card__form, .tda-quick-add';
  var SKIP_SELECTOR = '.mix-add-form-v6, .product-info form, .flagship-buy form';
  var RESET_MS = 1800;
  var warmed = false;

  function warm() {
    if (warmed) return;
    warmed = true;
    fetch('/cart.js', { credentials: 'same-origin' }).catch(function () {});
  }
  ['touchstart', 'pointerdown'].forEach(function (name) {
    document.addEventListener(name, warm, { once: true, passive: true });
  });

  function readCount() {
    var el = document.querySelector('.cart-link .cart-count');
    var n = el ? parseInt(el.textContent || '0', 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function setCount(count) {
    var link = document.querySelector('.cart-link');
    if (!link) return;
    var badge = link.querySelector('.cart-count');
    if (!count) { if (badge) badge.remove(); return; }
    if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; link.appendChild(badge); }
    badge.textContent = String(count);
  }

  // Keep the header count right when a page comes back from the back/forward cache.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count || 0); })
      .catch(function () {});
  });

  document.addEventListener('submit', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest(SKIP_SELECTOR)) return;
    var form = target.closest(FORM_SELECTOR);
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) return;

    event.preventDefault();

    var qtyField = form.querySelector('[name="quantity"]');
    var quantity = qtyField && qtyField.value ? parseInt(qtyField.value, 10) || 1 : 1;
    var button = form.querySelector('button[type="submit"]');
    var originalLabel = button ? button.textContent : '';
    var previousCount = readCount();
    var onCartPage = !!document.querySelector('[data-auto-cart]');

    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: idField.value, quantity: quantity }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add.js returned ' + response.status);
        setCount(previousCount + quantity);
        if (button) button.textContent = 'Added ✓';
        if (onCartPage) {
          if (window.TDACart && typeof window.TDACart.refresh === 'function') {
            window.TDACart.refresh().catch(function () { window.location.reload(); });
          } else {
            window.location.reload();
          }
          return;
        }
        fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCount(cart.item_count || 0); })
          .catch(function () {});
        window.setTimeout(function () {
          if (!button) return;
          button.disabled = false;
          button.textContent = originalLabel;
        }, RESET_MS);
      })
      .catch(function (error) {
        console.warn('[3da-fast-add] falling back to native submit:', error);
        if (button) { button.disabled = false; button.textContent = originalLabel; }
        HTMLFormElement.prototype.submit.call(form);
      });
  }, true);
})();
